import * as tips from "../../services/FieldsTips";
import InfoTooltip from "./InfoTooltip";

function GenerateLinksButtons(props) {
  const isByinteraVagasEmbDisable = props.selectedFields.source === "facebook";

  const { generateByInteraShorteners, generateBitly } = props;

  return (
    <>
      <br />
      <button
        style={{ marginRight: 10 }}
        className="btn btn-sm btn-primary"
        onClick={generateByInteraShorteners}
        disabled={isByinteraVagasEmbDisable}
      >
        Gerar byintera.in e vagas.emb
        <InfoTooltip
          tipsInfo={[
            tips.byinteraInBtnTip,
            tips.byinteraInTip,
            tips.vagasEmbTip,
          ]}
        />
      </button>

      <button
        style={{ marginRight: 10 }}
        className="btn btn-sm btn-primary"
        onClick={generateBitly}
      >
        Gerar bit.ly
        <InfoTooltip tipsInfo={[tips.bitlyBtnTip, tips.bitlyTip]} />
      </button>
    </>
  );
}

export default GenerateLinksButtons;
